<template>
  <div class="container">
    <head-top />
    <div class="content">
      <!-- 面包屑 -->
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ $t('navbar.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/active' }">{{ $t('navbar.activity') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('activity.detailTitle') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 展位介绍 -->
      <div class="active_detail">
        <div class="active_img">
          <img :src="activeMsg.column15" alt="" v-if="activeMsg.column15.substr(0,4) == 'http'" />
          <img :src="baseUrl + activeMsg.column15" alt="" v-else />
        </div>
        <div class="active_content">
          <p :title="activeMsg.actTitle" class="title">
            {{ activeMsg.actTitle }}
          </p>
          <!--  分割线    -->
          <div class="strip">
            <div class="strip_blue"></div>
          </div>
          <div class="active_time">
            <div class="time">
              <p>{{ $t('activity.startTime') }}{{ activeMsg.startTime }}</p>
              <p>{{ $t('activity.endTime') }}{{ activeMsg.endTime }}</p>
              <p :title="activeMsg.address">{{ $t('activity.placeBooth') }}&nbsp;{{ activeMsg.address }}</p>
            </div>
            <div class="collent">
              <button :class="[collectFlag ? 'collentSC' : 'cancleSC']" @click="collent">
                {{ collectFlag ? $t('common.collectActivity') : $t('common.clearCollect') }}
              </button>
            </div>
          </div>

          <!-- 点击进入展商详情 -->
          <div class="exhibitor" @click="exDetail()">
            <div class="logo">
              <img :src="exData.comCover" alt="" v-if="exData.comCover.substr(0,4) == 'http'" />
              <img :src="baseUrl + exData.comCover" alt="" v-else />
              <!-- <img v-else alt="" src="../../static/占位-展商-列表.png" /> -->
            </div>
            <div class="exhi_title">
              <p>{{ exData.companyNameC }}</p>
              <p v-if="exData.boothList" :title="exData.boothList" class="exNumber">
                {{ $t('common.boothNum1') }}&nbsp;&nbsp;<span v-for="(item, index) in exData.boothList" :key="index">{{ item }} &nbsp;</span>
              </p>
            </div>
          </div>
          <!-- 点击进入展商详情 -->
        </div>
      </div>

      <!-- 活动介绍 -->
      <div class="active_introduce">
        <h3 :style="{ width: lang == 'zh' ? '152px' : '250px' }">{{ $t('activity.activityIntroduce') }}</h3>
        <p v-html="activeMsg.actContent"></p>
      </div>
      <!-- 其他活动 -->

      <!-- <div class="other_active">
        <h3>其他活动</h3>
        <activelive />
      </div> -->
    </div>

    <foot-bottom />
  </div>
</template>

<script>
import headTop from '../../common/head.vue';
import footBottom from '../../common/footBottom.vue';
import activelive from './active_live.vue';
import { actDetail, exMsg, collectActive } from '../../../api/activePage'; //导入详情接口
import { forMat } from '../../../utils/common.js';
import * as tools from '../../../utils/roulink';

export default {
  components: {
    headTop,
    footBottom,
    activelive,
  },

  data() {
    return {
      baseUrl: forMat(),
      id: '', //活动id
      activeMsg: {}, //活动信息对象
      collectFlag: true,
      exData: {
        //展商信息
        companyNameC: '', // 中文名称
        comCover: '', //公司Logo
        boothList: [], //展位号
      },
      activ_include: ['标签内容测试标签内同测试', '标签内容测试标签内同测试', '标签内容测试标签内同测试', '标签内容测试标签内同测试'],
      activeData: [
        {
          activeImgurl: require('../../static/tupian.png'),
          title: '靠的住的硬实力山上机械新品发布会',
          activeDate: '2021-11-24 10：00',
          BoothNumber: '',
          company: '中国煤炭工业国际技术支持有限公司',
        },
      ],
      lang:''
    };
  },
  created(){
    this.lang = localStorage.getItem('lang');
    console.log(this.baseUrl);
  },
  methods: {
    //获取当前的活动信息
    async activeDetail(dataItem) {
      let { data } = await actDetail(dataItem);
      // console.log("返回的信息是：", data);
      this.activeMsg = data.data; //把活动信息信息赋值给activeMsg
      // console.log("活动信息的内容",this.activeMsg);
      this.activeMsg.collectStatus == 0 ? (this.collectFlag = true) : (this.collectFlag = false);
      try {
        let ex = await exMsg({ id: this.activeMsg.exhId }); //获取到展商信息
        this.exData = ex.data.data;
        // console.log("活动详情信息",this.exData);
        var arr = [];
        ex.data.data.hzBoothList.map((item) => {
          arr.push(item.boothNum);
        });
        this.exData.boothList = arr;
      } catch (err) {
        console.log(err);
      }
      //  console.log("展商信息是：",  this.exData);
    },
    //收藏活动
    async collent() {
      let collObj = {};
      const state = this.activeMsg.collectStatus;
      state == 0 ? (collObj.flag = true) : (collObj.flag = false);
      collObj.objId = String(this.activeMsg.id);
      collObj.type = 4;
      try {
        const { data } = await collectActive(collObj);
        if (state == 0) {
          if (data.code == 200) {
            this.collectFlag = false;
            this.activeMsg.collectStatus = !this.activeMsg.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
            this.getAct(this.actUpDatas);
            return false;
          } else {
            // this.$message({
            //   showClose: true,
            //   message: data.msg,
            //   type: "warning",
            // });
            tools.login(3);
          }
        } else {
          if (data.code == 200) {
            this.collectFlag = true;
            this.activeMsg.collectStatus = !this.activeMsg.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'success',
            });
            this.getAct(this.actUpDatas);
            return false;
          } else {
            tools.login(3);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    //进入展商详情
    exDetail() {
      this.$router.push({
        name: 'exhibition_det',
        query: {
          id: this.activeMsg.exhId,
        },
      });
    },

    //活动切换
    toggle() {
      if (this.collent_toggle == true) {
        this.collent_toggle = false;
      } else if (this.collent_toggle == false) {
        this.collent_toggle = true;
      }
    },
  },

  //拿到活动id
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //路由钩子函数
      const id = vm.$route.query.id;
      vm.id = id;
      // console.log(vm.id);
      vm.activeDetail({ id: id }); //调用接口
    });
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.container {
  width: 100%;
  margin-top: 120px;

  // height: 2010px;
  .content {
    width: 1270px;
    // border: 1px solid red;
    margin: 0 auto;
    margin-bottom: 70px;

    .nav {
      margin: 20px 0 45px;
    }

    .active_detail {
      margin-top: 45px;
      height: 436px;
      display: flex;

      .active_img {
        width: 694px;

        margin-right: 80px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .active_content {
        width: 496px;
        height: 426px;
        padding-top: 10px;
        // border: 1px solid red;

        //分割线
        .strip {
          width: 100%;
          height: 3px;
          background: #e5f0f8;
          //margin-bottom: 26px;
          //position: relative;
          .strip_blue {
            background: #006fb8;
            height: 100%;
            width: 50%;
          }
        }
        .title {
          width: 482px;
          //   height: 75px;
          font-size: 29px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 45px;
          //   border: 1px solid red;
          margin-bottom: 20px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .active_time {
          display: flex;

          .time {
            // border: 1px solid red;
            width: 260px;
            //border-top: 3px #006fb8 solid;

            p {
              margin-top: 20px;
              font-size: 16px;
            }
          }

          .collent {
            .collentSC {
              border: none;
              width: 172px;
              height: 54px;
              background: #fdd000;
              border-radius: 4px;
              /*   color: white; */
              color: #006fb8;
              font-size: 18px;
              margin: 22px 0 0 50px;
            }

            .cancleSC {
              border: none;
              width: 172px;
              height: 54px;
              background: #aaa9a3;
              border-radius: 4px;
              color: white;
              font-size: 18px;
              margin: 22px 0 0 50px;
            }
          }
        }

        .exhibitor {
          width: 489px;
          height: 136px;
          display: flex;
          margin-top: 51px;
          border: 1px solid #e0e0e0;

          .logo {
            width: 237px;
            height: 136px;
            //padding: 0 56px;
            box-sizing: border-box;
            border: 1px solid #e0e0e0;
            flex-shrink: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px 36px;

            img {
              max-width: 100%;
              max-height: 100%;
            }
          }

          .exhi_title {
            box-sizing: border-box;
            padding-left: 20px;
            p {
              font-size: 18px;
              margin-top: 20px;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              max-width: 230px;
            }
            .exNumber {
              span {
                font-weight: 800;
              }
            }

            p:last-child {
              font-size: 14px;
            }
          }
        }
      }
    }

    .active_introduce {
      margin-top: 70px;

      h3 {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-bottom: 28px;
        color: #006fb8;
        border-left: 3px solid #006fb8;
        border-right: 3px solid #006fb8;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
      }

      p {
        // line-height: 22px;
        line-height: 27px;
        font-size: 18px;
      }
    }

    .other_active {
      margin-top: 81px;

      h3 {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 29px;
      }

      .other_item {
        display: flex;
        margin-top: 30px;

        .item {
          width: 294px;
          height: 354px;
          margin-top: 20px;
          margin-right: 28px;
          border: 1px solid #e0e0e0;

          .vedio {
            width: 295px;
            height: 174px;
            margin-bottom: 20px;
            border: 1px yellow solid;
            position: relative;

            .shoucang {
              position: absolute;
              top: -1;
              right: 0;
            }

            .vedio_picture {
              width: 100%;
              height: 100%;
            }
          }

          .title {
            box-sizing: border-box;
            height: 117px;
            padding: 0px 35px 50px 24px;

            p {
              margin-top: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
